module.exports = __webpack_public_path__ + "img/lock.8705db21.png";